import BuyerApi from './buyer-api';
import { BuyerProjectInteractionTracking } from '@bark/bark-core';
import moment from 'moment';

export default function () {
	const { Handlebars } = window;
	const buyerApi = BuyerApi();
	const experimentTracking = BuyerProjectInteractionTracking();

	const state = {
		projectIdHash: '',
		projectCreated: '',
		currentValue: '0',
	};

	const domElements = {
		urgentRequestMobileContainerId: 'urgent-request-mobile-container',
		urgentRequestUpdateModalId: 'urgent-request-update-modal',
	};

	const hbTemplates = {
		urgentRequestMobile: null,
	};

	const init = (projectIdHash, projectCreatedAt) => {
		if (projectIdHash && projectCreatedAt) {
			state.projectIdHash = projectIdHash;
			state.projectCreated = projectCreatedAt;

			buyerApi
				.getUrgentRequestSetting({
					projectIdHash: state.projectIdHash,
				})
				.then((result) => {
					if (result?.data?.value) {
						state.currentValue = result.data.value;
					}

					drawAll();
				});
		}
	};

	const updateUrgentRequestSetting = (value) => {
		if (value) {
			$(`#${domElements.urgentRequestUpdateModalId} .spinner-border`).removeClass(
				'd-none',
			);
			buyerApi
				.updateUrgentRequestSetting({
					projectIdHash: state.projectIdHash,
					value,
				})
				.then((result) => {
					if (result?.data?.value) {
						state.currentValue = result.data.value;
					}

					drawAll();

					$(`#${domElements.urgentRequestUpdateModalId} .spinner-border`).addClass(
						'd-none',
					);
					$(`#${domElements.urgentRequestUpdateModalId}`).modal('hide');
				})
				.catch(() => {
					$(`#${domElements.urgentRequestUpdateModalId} .spinner-border`).addClass(
						'd-none',
					);
					$(`#${domElements.urgentRequestUpdateModalId}`).modal('hide');
				});
		}
	};

	const drawAll = () => {
		drawUrgentRequest();
		bindListeners();
	};

	const drawUrgentRequest = () => {
		$(`#${domElements.urgentRequestMobileContainerId}`).empty();

		if (!projectCreatedMinutesAgo(5) || isUrgentRequest()) {
            if (!hbTemplates.urgentRequestMobile) {
                const template = document.getElementById('urgent-request-mobile-template');
                if (template) {
                    hbTemplates.urgentRequestMobile = Handlebars.compile(template.innerHTML);
                } else {
                    return;
                }
            }

			let mobileHtml = hbTemplates.urgentRequestMobile({
				isUrgentRequest: isUrgentRequest(),
			});
			$(`#${domElements.urgentRequestMobileContainerId}`).append(mobileHtml);
		}
	};

	const projectCreatedMinutesAgo = (minutes) => {
		let currentTime = moment.utc();
		let createdAt = moment.utc(state.projectCreated, 'YYYY-MM-DD HH:mm:SS');
		return currentTime.diff(createdAt, 'm') >= minutes;
	};

	const isUrgentRequest = () => {
		return state.currentValue === '1';
	};

	const bindListeners = () => {
		$('.js-urgent-request-btn')
			.off('click')
			.on('click', function (e) {
				e.preventDefault();
				$(`#${domElements.urgentRequestUpdateModalId}`).modal('show');
				experimentTracking.submitExpActWithVal('Urgent requests - clicked button');
			});

		$('.js-urgent-request-confirm-btn')
			.off('click')
			.on('click', function (e) {
				e.preventDefault();
				updateUrgentRequestSetting(1);
				experimentTracking.submitExpActWithVal('Urgent requests - clicked confirm');
			});

		$('.js-urgent-request-cancel-btn').on('click', function (e) {
			experimentTracking.submitExpActWithVal('Urgent requests - clicked cancel');
		});
	};

	return {
		init,
	};
}
